require('./angular-resource');
module.exports = 'ngResource';



/*****************
 ** WEBPACK FOOTER
 ** ./~/angular-resource/index.js
 ** module id = 326
 ** module chunks = 1
 **/